import { render, staticRenderFns } from "./schUseDetail.vue?vue&type=template&id=5d655eb8&scoped=true"
import script from "./schUseDetail.vue?vue&type=script&lang=js"
export * from "./schUseDetail.vue?vue&type=script&lang=js"
import style0 from "./schUseDetail.vue?vue&type=style&index=0&id=5d655eb8&prod&lang=scss&scoped=true"
import style1 from "./schUseDetail.vue?vue&type=style&index=1&id=5d655eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d655eb8",
  null
  
)

export default component.exports